import { render, staticRenderFns } from "./SaveDashboardModal.vue?vue&type=template&id=0481e28c&"
import script from "./SaveDashboardModal.vue?vue&type=script&lang=js&"
export * from "./SaveDashboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports